module.exports = __webpack_public_path__ + "fa-regular-400.e6ff1c5d13b778627278.ttf";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-regular-400.ttf
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-regular-400.ttf
// module chunks = styles